export enum TaskIcons {
  'far fa-piggy-bank',
  'far fa-chart-pie',
  'far fa-landmark',
  'fas fa-star',
  'far fa-credit-card',
  'far fa-calendar-alt',
  'far fa-shield-alt',
  'far fa-chart-bar',
}

export enum TaskNames {
  'Savings',
  'Asset Allocation',
  'Finance',
  'Other',
  'Debt',
  'Calendar',
  'Security',
  'Investment',
}

export const MAX_TASKS = 10;

export const ICON_DEFAULT_VALUE = 0;

export const ACTION_STEPS_TOOLTIP_TEXT =
  'Action Steps are changes you can implement in the near future to help you meet your goals. If you have already implemented these Action Steps, please adjust your Current Plan to reflect these changes as this page is only a checklist.';

export const SUGGESTIONS_TOOLTIP_TEXT =
  'Suggestions are changes you can implement in the future to help you meet your goals. If are you going to implement these Suggestions, please adjust your Current Plan to reflect these changes as this page is only a checklist.';
